import Marketing from './Marketing.view';

export default Marketing;
